import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Logout from './Logout';
import Select from 'react-select';
import AppURL from '../api/AppURL';

const SupplierList = ({ onLogout }) => {
    const [suppliers, setSuppliers] = useState([]);
    const [form, setForm] = useState({ name: '', mobile_no: '', address: '', group_id: '' });
    const [editingId, setEditingId] = useState(null);

    const token = localStorage.getItem('auth_token');

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const fetchSuppliers = () => {
        axios.get(AppURL.getsupplier, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                setSuppliers(response.data.suppliers || response.data);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = editingId
            ? `${AppURL.updateSupplier}/${editingId}`
            : AppURL.addSupplier;

        const method = editingId ? 'put' : 'post';

        axios({
            method: method,
            url: url,
            data: {
                customer_name: form.name,
                mobile_no: form.mobile_no,
                address: form.address,
                team_id: form.group_id,
            },
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            },
        })
            .then(() => {
                setForm({ name: '', mobile_no: '', address: '', group_id: '' });
                setEditingId(null);
                fetchSuppliers();
            });
    };

    const handleEdit = (id) => {
        axios.get(`${AppURL.editSupplier}/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => {
                const data = res.data.data;
                setForm({
                    name: data.name,
                    mobile_no: data.mobile_no,
                    address: data.address,
                    group_id: data.group_id,
                });
                setEditingId(data.id);
            });
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete?")) {
            axios.delete(`${AppURL.deleteSupplier}/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(() => fetchSuppliers());
        }
    };


    const [groups, setGroups] = useState([]);

    useEffect(() => {
        fetchSuppliers();
        axios.get(AppURL.allGroup, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setGroups(res.data.groups);
        });
    }, []);

    const groupOptions = groups.map(group => ({
        value: group.id,
        label: group.name,
    }));

    const handleDownload = () => {
        const token = localStorage.getItem("auth_token");

        axios({
            url: AppURL.getsupplierreport,
            method: 'GET',
            responseType: 'blob', // PDF ফাইল ডাউনলোডের জন্য blob দরকার
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/pdf',
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'supplier_report.pdf'); // ডাউনলোড ফাইলের নাম
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((error) => {
                console.error('Download failed:', error);
                alert('Report download failed.');
            });
    };



    return (
        <div className="container mt-5 pt-5">
            <Logout onLogout={onLogout} />

            <h4 className="mb-3">{editingId ? "Edit" : "Add"} Supplier</h4>
            <form onSubmit={handleSubmit} className="mb-5">
                <div className="row">
                    <div className="col-md-2">
                        <input type="text" className="form-control mb-2" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                    </div>
                    <div className="col-md-2">
                        <input type="text" className="form-control mb-2" placeholder="Mobile" value={form.mobile_no} onChange={e => setForm({ ...form, mobile_no: e.target.value })} required />
                    </div>
                    <div className="col-md-3">
                        <input type="text" className="form-control mb-2" placeholder="Address" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} required />
                    </div>
                    <div className="col-md-3">
                        <Select
                            options={groupOptions}
                            value={groupOptions.find(option => option.value === form.group_id)}
                            onChange={selectedOption =>
                                setForm({ ...form, group_id: selectedOption ? selectedOption.value : '' })
                            }
                            placeholder="Select Group"
                            isClearable
                        />
                    </div>



                    <div className="col-md-2">
                        <button className="btn btn-success w-100">{editingId ? "Update" : "Add"}</button>
                    </div>
                </div>
            </form>

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">Supplier List</h4>
                <button onClick={handleDownload} className="btn btn-sm btn-info">
                    Download Report
                </button>
            </div>


            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>SL</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Address</th>
                        <th>Group Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {suppliers.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.mobile_no}</td>
                            <td>{item.address}</td>
                            <td>{item.group?.name || 'N/A'}</td>

                            <td>
                                <div className="d-flex justify-content-around">
                                    <button onClick={() => handleEdit(item.id)} className="btn btn-primary btn-sm me-1">Edit</button>
                                    <button onClick={() => handleDelete(item.id)} className="btn btn-danger btn-sm">Delete</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
};

export default SupplierList;
